import { Container, Button, Box } from "@chakra-ui/react";
import dayjs from "dayjs";
import AdminDataTable from "components/AdminDataTable/AdminDataTable";
import { useNavigate } from "react-router-dom";

const Subscribers = () => {
  const history = useNavigate();
  const isLoading = false;

  const Items = [
    {
      subscriber_name: "Subscriber 1",
      subscriber_plan: "Plan 1",
    },
    {
      subscriber_name: "Subscriber 3",
      subscriber_plan: "Plan 2",
    },
    {
      subscriber_name: "Subscriber 2",
      subscriber_plan: "Plan 3",
    },
    {
      subscriber_name: "Subscriber 4",
      subscriber_plan: "Plan 4",
    },
    {
      subscriber_name: "Subscriber 5",
      subscriber_plan: "Plan 5",
    },
  ];

  const COLUMNS = [
    {
      Header: "Subscriber Name",
      accessor: "subscriber_name",
    },
    {
      Header: "Subscriber Plan",
      accessor: "subscriber_plan",
    },

    {
      Header: "Expires On",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>;
      },
    },
  ];
  return (
    <Container mt="4" maxW="container.xl">
      <Button
        variant="secondary"
        onClick={() => {
          history(-1);
        }}
      >
        Back
      </Button>
      <Box p={"0 10px"} mt="2">
        <Box mb="20px" fontSize="30px">
          Subscribers
        </Box>
        <AdminDataTable
          ariaLabel="Subscribers"
          columns={COLUMNS}
          data={Items}
          loading={isLoading}
          paginate
          showRowNumbers
        />
      </Box>
    </Container>
  );
};

export default Subscribers;
